<template>
  <fragment>
    <section class="h-full py-8 max-w-screen-lg mx-auto flex flex-col items-center justify-center">
      <transition name="fade" appear>
        <h1 class="text-7xl text-gray-800 dark:text-white text-center font-semibold leading-none tracking-tighter mb-4">
          Yuxuan PANG's personal website
        </h1>
      </transition>
      <transition name="fade" appear>
        <router-link to="/">
          <button
            class="btn bg-indigo-600 dark:bg-indigo-400 py-3 px-7 rounded-md text-white flex items-center gap-3"
            @click="switchLayout(layouts.centered)">
            About Me
            <v-icon name="chevron-right" class="fill-current" />
          </button>
        </router-link>
      </transition>
    </section>
  </fragment>
</template>

<script>
import { layouts } from "@/store";
import { themes } from "@/store";
import { mutations } from "@/store/mutationsNames";

export default {
  name: "TheLandingPages",
  data() {
    return {
      layouts: layouts,
    };
  },
  computed: {
    currentThemeIsDark() {
      return this.$store.state.theme === themes.dark;
    },
    currentLayout() {
      return this.$store.state.layout;
    },
  },
  methods: {
    switchLayout(layout) {
      this.$store.commit(mutations.SetLayout, layout);
    },
  },
};
</script>
